import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { MarketingCampaign } from "../../marketing.types";
import { requestGetMarketingCampaigns } from "./getMarketingCampaigns.request";

const useMarketingCampaigns = (
  options?: QueryOptions<MarketingCampaign[], ApiServiceError<ApiError>>
) => {
  const { data: campaigns, ...rest } = useQuery({
    queryKey: ["marketing", "campaigns", "list"],
    queryFn: requestGetMarketingCampaigns,
    onError: toastServerError,
    ...options
  });

  return { campaigns: campaigns ?? [], ...rest };
};

export default useMarketingCampaigns;
